import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=194f13c8&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=194f13c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f13c8",
  null
  
)

export default component.exports